<template>
    <div class="chart-item-content">
        <div class="chart-time">{{item.created_at}}</div>
        <div class="chart-item">
            <div v-if="!isMe" class="head-item mr-10">
                <img class="head-item-img" :src="userHead" alt="">
            </div>
            <el-popconfirm title="是否翻译该内容？"
                           @onConfirm="trans('zh')"
                           @onCancel="trans('jp')"
                           confirmButtonText='中文'
                           cancelButtonText='日文'
                           :class="isMe?'ml-a':'mr-a'">
                <div slot="reference" class="text-content" :class="isMe?'ml-a is-right':'mr-a is-left'">
                    <div v-html="newText"></div>
                    <div v-for="(item,index) in transList" :key="index">{{item.dst}}</div>
                </div>
            </el-popconfirm>
            <div v-if="isMe" class="head-item ml-10">
                <img class="head-item-img" :src="`/api/v1/file/${head}`" alt="">
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "ChartItem",
    props: {
        isMe: {
            type: Boolean,
            default: true
        },
        head: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            traning: false,
            isTran: false,
            transList: []
        }
    },
    computed: {
        userHead() {
            if (this.item.avar && `${this.item.avar}`.indexOf('http') >= 0) {
                return this.item.avar
            }
            return `/api/v1/file/${this.item.avar || 102}`
        },
        newText(){
            this.item.content = this.item.content || this.item.msg;
            let phone = /电话/g
            let wx = /wechat/g
            let weixin = /微信/g
            let reg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/g
            let reg1 = /(0[0-9]{2,3}[\-]?[2-9][0-9]{6,7}[\-]?[0-9]?)|(1[358]{1}[0-9]{9})/g
            let pnum = /^1\d{10}$/g
            let wxx = /wx/g
            let wxq = /weixin/g
            let num1 = /^(.*?)080\d{8}$/g
            let num2 = /^(.*?)090\d{8}$/g
            let num3 = /^(.*?)070\d{8}$/g
            this.item.content = this.item.content.replace(phone, '***');
            this.item.content = this.item.content.replace(wx, '***');
            this.item.content = this.item.content.replace(weixin, '***');
            this.item.content = this.item.content.replace(reg, '***');
            this.item.content = this.item.content.replace(reg1, '***');
            this.item.content = this.item.content.replace(pnum, '***');
            this.item.content = this.item.content.replace(wxx, '***');
            this.item.content = this.item.content.replace(wxq, '***');
            this.item.content = this.item.content.replace(num1, '***');
            this.item.content = this.item.content.replace(num2, '***');
            this.item.content = this.item.content.replace(num3, '***');
            return `${this.item.content}`.replace(/\n/g, '<br>')
        }
    },
    methods: {
        async trans(to) {
            this.traning = true;
            let [e, data] = await this.$api.transApi({to, q: this.item.content})
            this.traning = false;
            this.isTran = true;
            this.transList = data.result;
        },
    },
}
</script>

<style scoped lang="less">
.chart-time{
    width: fit-content;
    font-size: 12px;
    margin: auto;
    padding: 2px 4px;
    color: #ffffff;
    line-height: 1;
    border-radius: 4px;
    background-color: rgba(112,112,112,0.5);
}
.chart-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 20px 0;

    .head-item {
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        border-radius: 100%;
        background-color: #ffffff;
        filter: drop-shadow(0 0 6px #cccccc);

        .head-item-img {
            width: 100%;
            height: 100%;
            border-radius: 100%;
            object-fit: cover;
        }
    }

    .text-content {
        padding: 10px;
        box-sizing: border-box;
        background-color: #ffffff;
        min-height: 40px;
        font-size: 14px;
        line-height: 1.5;
        border-radius: 6px;
        max-width: 360px;
        position: relative;
        cursor: pointer;
        outline: none;
    }
}

.is-left {
    filter: drop-shadow(0 0 6px #cccccc);

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        border-left: 10px solid transparent;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 10px solid #ffffff;
        transform: translate(-18px, 12px);
    }
}

.is-right {
    background-color: #e44646 !important;
    color: #ffffff;
    filter: drop-shadow(0 0 6px #cccccc);

    &::before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        border-left: 10px solid #e44646;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 10px solid transparent;
        transform: translate(18px, 12px);
    }
}
</style>
